import { useModals } from '@any-ui-react/modals';
import type { ReactNode } from 'react';
import { v4 as uuid } from 'uuid';

import type { EmergencyContactType } from '@/common/types';

import { EmergencyContactForm } from './EmergencyContactForm';

export const EmergencyContactModal = ({
  children,
  onSuccess,
  emergencyContact,
  className,
  isNewRecord = false,
}: {
  children: ReactNode;
  onSuccess: (data: EmergencyContactType) => void;
  emergencyContact?: EmergencyContactType;
  className?: string;
  isNewRecord?: boolean;
}) => {
  const modalId = uuid();
  const { openModal, closeModal } = useModals();

  const onClick = () => {
    openModal({
      modalId,
      closeOnClickOutside: false,
      closeOnEscape: false,
      centered: true,
      title: `${!isNewRecord ? 'Update' : 'Add new'} Emergency Contact`,
      size: 'lg',
      children: (
        <EmergencyContactForm
          emergencyContact={emergencyContact}
          onCancel={() => closeModal(modalId)}
          onSuccess={data => {
            onSuccess(data);
            closeModal(modalId);
          }}
        />
      ),
    });
  };

  return (
    <span className={className} onClick={onClick}>
      {children}
    </span>
  );
};
